import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent, Button, DialogActions, Box,
} from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from "material-react-table";

import {useGetMonitorPianAttDettByDipAndData} from "./Services";

interface Props {
  data: {
    coddip: string;
    day: string;
    mese: number;
    anno: number;
    nomedip: string;
  } | null;
}

const MonitorPianAttTable: React.FC<Props> = ({
  data,
}) => {
  // ----------------------
  // Build DATAREG
  // ----------------------
  // const datareg = data
  //   ? `${data.anno}-${String(data.mese).padStart(2, "0")}-${String(data.day).padStart(2, "0")}`
  //   : "";

  const datareg = data
    ? `${String(data.day).padStart(2, "0")}/${String(data.mese).padStart(2, "0")}/${data.anno}`
    : "";

  const datareg2 = data
    ? `${data.anno}-${String(data.mese).padStart(2, "0")}-${String(data.day).padStart(2, "0")}`
    : "";


  // ----------------------
  // API CALL
  // ----------------------
  const {
    data: { results = [] } = {},
    isLoading,
  } = useGetMonitorPianAttDettByDipAndData(data?.coddip ?? "", datareg2);

  // ----------------------
  // Columns
  // ----------------------
  const columns = useMemo<MRT_ColumnDef<any>[]>(() => [
  { accessorKey: 'id', header: 'Id', size: 2},
  { accessorKey: 'ditta', header: 'Ditta', size: 2 },
  // { accessorKey: 'coddip', header: 'CodDip', size: 20 },
  { accessorKey: 'nomedip', header: 'NomeDip', size: 5 },
  { accessorKey: 'ref', header: 'Ref', size: 5 },
  // { accessorKey: 'tipodip', header: 'TipoDip', size: 20 },
  // { accessorKey: 'codprog', header: 'CodProg', size: 40 },
  { accessorKey: 'desprog', header: 'DesProg', size: 5 },
  // { accessorKey: 'codnodo', header: 'CodNodo', size: 40 },
  { accessorKey: 'desnodo', header: 'DesNodo', size: 5 },
  // { accessorKey: 'idcli', header: 'IdCli', size: 40 },
  // { accessorKey: 'priorita', header: 'Priorita', size: 20 },
  { accessorKey: 'note', header: 'Note', size: 50 },
  { accessorKey: 'datainizio', header: 'DataInizio', size: 20 },
  { accessorKey: 'datafine', header: 'DataFine', size: 20 },
  { accessorKey: 'datareg', header: 'Data', size: 20 },
  { accessorKey: 'orainizio', header: 'OraInizio', size: 5 },
  { accessorKey: 'orafine', header: 'OraFine', size: 5 },
  { accessorKey: 'orepian', header: 'OrePian', size: 5 },

], []);

  // ----------------------
  // Table
  // ----------------------
  const table = useMaterialReactTable({
    columns,
    data: results,

    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableColumnActions: false,
    enableSorting: false,
    enablePagination: false,

    state: {
      isLoading,
    },

    muiTableProps: {
      sx: {
        '& .MuiTableCell-root': {
          padding: '2px 6px',
          fontSize: '0.75rem',
        },
      },
    },
    muiTableBodyRowProps: {
      sx: { height: '28px' },
    },
    muiTableHeadRowProps: {
      sx: { height: '30px' },
    },
  });

  // ----------------------
  // UI
  // ----------------------
  return (
           <MaterialReactTable table={table} />
  );
};

export default MonitorPianAttTable;